import type { FaireProductEntity } from "../../entity_types/product";

export const p_7usm72mgsp: FaireProductEntity = {
  token: "p_7usm72mgsp",
  type: "product",
  name: "Bloodstone Mini Hearts",
  brandToken: "b_92q2hhsl",
  brandName: "Tiny Rituals",
  imageUrl:
    "https://cdn.faire.com/fastly/2943753eafc1211c1232eb621fb04c8201eec6699103ecd5a54b0208c4477963.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a5ec0008e2d43f03b4fb19e8d1e4fa4b70576467f8909933a2fab33a542c82e6.jpeg",
  ],
  priceDollars: 27,
  description:
    "<br /><br />DETAILS<br /><br /><br /><br />Unique and genuine  Bloodstone gemstone<br />Includes 3 Mini Hearts per Set<br />Approx. 1.25 inches wide<br />Color, shape, size, and markings will vary<br />Comes with a description card<br /><br />",
  tags: [],
  msrpDollars: 54,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:42.507Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
